import { noop } from 'common/utils';
import { DependencyList, useEffect } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';

import { defaultContext } from '../constants/forms';
import { AiVariantContext } from '../types';

type UseMelContextForm = (
  watchCallback?: (value: any) => void,
  callbackDeps?: DependencyList,
) => UseFormReturn<AiVariantContext, any>;

const useMelContextForm: UseMelContextForm = (watchCallback = noop, callbackDeps = []) => {
  const form = useForm<AiVariantContext>({ defaultValues: defaultContext });
  const { watch } = form;

  useEffect(() => {
    const { unsubscribe } = watch(watchCallback);
    return () => unsubscribe();
  }, [...callbackDeps, watch]);

  return form;
};

export { useMelContextForm };
